import React, { useMemo } from "react";
import { NavLink, Outlet, useLocation, Navigate } from "react-router-dom";

/**
 * Birleşik merkez kabuğu — alt sayfalar Outlet ile render edilir.
 * Alt sayfalar kendi ?tab= parametrelerini kullanmaya devam eder (çakışma yok).
 */
export default function MerkezHubShell({
    title,
    subtitle,
    badge = "Birleşik Merkez",
    tabs = [],
    basePath,
}) {
    const { pathname } = useLocation();

    const activeId = useMemo(() => {
        const hit = tabs.find((t) => pathname.includes(`${basePath}/${t.id}`));
        return hit?.id || tabs[0]?.id;
    }, [pathname, tabs, basePath]);

    if (pathname.replace(/\/$/, "") === basePath.replace(/\/$/, "") && tabs[0]) {
        return <Navigate to={`${basePath}/${tabs[0].id}`} replace />;
    }

    return (
        <div className="min-h-screen bg-[#060a12]">
            <div className="border-b border-white/5 bg-gradient-to-r from-[#0a1018] via-[#0b1220] to-[#0a1018]">
                <div className="max-w-[1600px] mx-auto px-3 sm:px-4 py-3">
                    <div className="flex flex-wrap items-center justify-between gap-3">
                        <div className="min-w-0">
                            <p className="text-[9px] uppercase tracking-[0.2em] text-[#D4AF37] font-semibold">
                                {badge}
                            </p>
                            <h1 className="font-display text-lg sm:text-xl text-white mt-0.5">{title}</h1>
                            {subtitle ? (
                                <p className="text-[11px] text-slate-500 mt-0.5 max-w-2xl line-clamp-1 hidden sm:block">{subtitle}</p>
                            ) : null}
                        </div>
                    </div>

                    <nav className="mt-3 flex flex-wrap gap-1" aria-label={`${title} sekmeleri`}>
                        {tabs.map((t) => {
                            const Icon = t.icon;
                            const to = `${basePath}/${t.id}`;
                            const active = activeId === t.id;
                            return (
                                <NavLink
                                    key={t.id}
                                    to={to}
                                    className={`inline-flex items-center gap-1.5 px-3.5 py-2 rounded-lg text-xs font-semibold transition border ${
                                        active
                                            ? "bg-[#D4AF37]/20 text-[#F3E5AB] border-[#D4AF37]/45 shadow-[0_0_0_1px_rgba(212,175,55,0.15)]"
                                            : "bg-white/[0.02] text-slate-400 border-white/10 hover:text-slate-200 hover:border-white/20"
                                    }`}
                                >
                                    {Icon ? <Icon className="h-3.5 w-3.5" /> : null}
                                    {t.label}
                                </NavLink>
                            );
                        })}
                    </nav>
                </div>
            </div>

            <div className="hub-outlet max-w-[1600px] mx-auto hub-outlet-compact">
                <Outlet />
            </div>
        </div>
    );
}

/** Eski URL → yeni hub yolu; query string korunur */
export function LegacyHubRedirect({ to }) {
    const { search, hash } = useLocation();
    return <Navigate to={`${to}${search}${hash}`} replace />;
}
